import { getNotes } from "components/notes/lib/data";
import { useQuery } from "react-query";

export const useNotes = ({ clientCode, shipmentKey, binTrackingNumber, taskTypeList, showAllNotes }) => {
    return useQuery({
        queryKey: ["notes", taskTypeList, clientCode],
        queryFn: () => getNotes({ clientCode, shipmentKey, binTrackingNumber, taskTypeList, showAllNotes }),
    });
};
